module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAADQSURBVDiNzZTRDcIwEEOdigE6QkboCGxANyiboE7ACB0BNgA26AYdgWzw+MlHaK5VkYJUf0U+3cUXK5YMADUwsYwJ8FaviwPOkrqEryU1VkOCUVKI5yBpdM71Ai4rSn7F1QHvqKgEggMoNEySVJUc9peBB4MLkvrEwTV0ko5fjOXUVjVAM2+2FLbAa6PC05zYv8vWypJ0n63sk8dPa232KQxTBuuGGAjDjMtMsVbOvmFMltqoZQGyZEowVrZqWYTt3+UqulYKTwEeeBQI1xvgPygrSOpc46dqAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homework.png
// module id = IJos
// module chunks = 1